var EntityProcedureEnum = /* @__PURE__ */ ((EntityProcedureEnum2) => {
  EntityProcedureEnum2["ENTITY_PROCEDURE_SCHEDULE_CARD"] = "entity-procedure-schedule-card";
  EntityProcedureEnum2["ENTITY_PROCEDURE_SCHEDULE_CARD_TRIGGER"] = "entity-procedure-schedule-card--trigger";
  EntityProcedureEnum2["ENTITY_PROCEDURE_SCHEDULE_CARD_TOGGLE"] = "entity-procedure-schedule-card--toggle";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PLACE_CARD"] = "entity-procedure-place-card";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PLACE_CARD_NAME"] = "entity-procedure-place-card--name";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PLACE_CARD_SCHEDULES"] = "entity-procedure-place-card--schedules";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PLACE_CARD_INSTALLMENT"] = "entity-procedure-place-card--installment";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PROFESSIONAL_CARD"] = "entity-procedure-professional-card";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PROFESSIONAL_CARD_NAME"] = "entity-procedure-professional-card--name";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PROFESSIONAL_CARD_SCHEDULES"] = "entity-procedure-professional-card--schedules";
  EntityProcedureEnum2["ENTITY_PROCEDURE_PROFESSIONAL_CARD_INSTALLMENT"] = "entity-procedure-professional-card--installment";
  EntityProcedureEnum2["ENTITY_PROCEDURE_SECTION"] = "entity-procedure-section";
  EntityProcedureEnum2["ENTITY_PROCEDURE_SECTION_TITLE"] = "entity-procedure-section--title";
  EntityProcedureEnum2["ENTITY_PROCEDURE_SECTION_TAB_IN_PERSON"] = "entity-procedure-section--tab--in-person";
  EntityProcedureEnum2["ENTITY_PROCEDURE_SECTION_TAB_TELEHEALTH"] = "entity-procedure-section--tab--telehealth";
  EntityProcedureEnum2["ENTITY_PROCEDURE_SECTION_ERROR"] = "entity-procedure-section--error";
  EntityProcedureEnum2["ENTITY_PROCEDURE_SECTION_RETRY"] = "entity-procedure-section--retry";
  EntityProcedureEnum2["ENTITY_PROCEDURE_SECTION_SEE_MORE"] = "entity-procedure-section--see-more";
  EntityProcedureEnum2["ENTITY_PROCEDURE_SECTION_ANCHOR_BUTTON"] = "entity-procedure-section--anchor-button";
  return EntityProcedureEnum2;
})(EntityProcedureEnum || {});
export {
  EntityProcedureEnum
};
